export const EMAIL_PROFILE_NOT_FOUND = 'Email profile not found';
export const EXPIRED_REFRESH_TOKEN = 'expired refresh token';
export const UNAUTHORIZED = 'Unauthorized';
